import { Icon } from './types';

export const Close = ({ svgProps, pathProps }: Icon) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      d="M8.33333 0C3.725 0 0 3.725 0 8.33333C0 12.9417 3.725 16.6667 8.33333 16.6667C12.9417 16.6667 16.6667 12.9417 16.6667 8.33333C16.6667 3.725 12.9417 0 8.33333 0ZM12.5 11.325L11.325 12.5L8.33333 9.50833L5.34167 12.5L4.16667 11.325L7.15833 8.33333L4.16667 5.34167L5.34167 4.16667L8.33333 7.15833L11.325 4.16667L12.5 5.34167L9.50833 8.33333L12.5 11.325Z"
      fill="#333333"
      {...pathProps}
    />
  </svg>
);
